module.exports = __webpack_public_path__ + "static/media/edu.a4aa5f99.svg";